const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1baa3f189e53eda4e4b63d472c8674c13ca9c217"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["seljak@long-forme"]={id:"1baa3f189e53eda4e4b63d472c8674c13ca9c217"};
      